// extracted by css-extract-rspack-plugin
export default {"extra-icons":"extra-icons-RHP7Zr","extraIcons":"extra-icons-RHP7Zr"};